module.exports = __webpack_public_path__ + "static/img/yyzx.19e3f2b8.png";